<div class="auth-container">
  <ng-container
    *ngComponentOutlet="
      components[config.variant].component;
      inputs: components[config.variant].inputs
    "
  />
</div>
